export const SITE = {
  name: "Clube Digital",
  cnpj: "60.143.193/0001-61",
  email: "contato@cd4iu.com.br",
  emailSubject: "Quero falar sobre um projeto digital",
  emailBody:
    "Olá, Clube Digital!\n\nGostaria de conversar sobre uma solução digital para minha empresa.\n\nNome:\nEmpresa:\nTelefone/WhatsApp:\nO que preciso:",
  phoneDisplay: "(22) 99281-1258",
  whatsappNumber: "5522992811258",
  whatsappMessage: "Olá! Gostaria de falar sobre meu projeto.",
};

export const getEmailLink = () =>
  SITE.email
    ? `mailto:${SITE.email}?subject=${encodeURIComponent(SITE.emailSubject)}&body=${encodeURIComponent(SITE.emailBody)}`
    : null;

export const getWhatsAppLink = () =>
  SITE.whatsappNumber
    ? `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(SITE.whatsappMessage)}`
    : null;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};
